var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#496E2D"
    },
    d: "M255.999,0c-19.114,0-37.733,2.113-55.651,6.085l-11.13,249.914l11.13,249.915 c17.919,3.972,36.538,6.086,55.651,6.086c141.385,0,256-114.616,256-256.001C511.998,114.615,397.384,0,255.999,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#496E2D"
    },
    d: "M66.783,83.571C25.299,129.067,0.001,189.577,0.001,255.999S25.3,382.931,66.784,428.429 l11.13-172.43L66.783,83.571z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M374.421,193.099c12.595-35.106-1.555-73.287-31.922-92.303c5.462,0.711,10.93,1.997,16.326,3.932 c40.503,14.532,61.557,59.144,47.025,99.646c-14.532,40.505-59.144,61.557-99.647,47.025c-5.397-1.936-10.436-4.421-15.103-7.344 C326.63,248.682,361.826,228.205,374.421,193.099z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "304.564,91.173 293.619,105.315 276.79,99.276 286.856,114.054 275.913,128.194  293.078,123.188 303.146,137.964 303.686,120.092 320.852,115.085 304.023,109.048  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "334.116,137.252 323.171,151.393 306.341,145.354 316.408,160.132 305.464,174.272  322.629,169.264 332.697,184.043 333.239,166.17 350.404,161.162 333.574,155.124  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "252.46,107.955 241.515,122.095 224.686,116.058 234.753,130.835 223.809,144.976  240.973,139.969 251.041,154.746 251.583,136.874 268.748,131.867 251.919,125.828  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "251.26,160.737 240.316,174.878 223.486,168.84 233.554,183.618 222.608,197.758  239.775,192.752 249.842,207.528 250.383,189.656 267.549,184.649 250.718,178.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "301.486,178.758 290.541,192.898 273.712,186.86 283.78,201.638 272.834,215.777  290.001,210.771 300.068,225.549 300.609,207.675 317.775,202.669 300.944,196.631  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M66.783,83.571v344.857c34.88,38.254,81.21,65.879,133.565,77.485V6.085 C147.992,17.691,101.664,45.316,66.783,83.571z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "117.753,134.785 95.392,118.127 95.392,94.57 117.753,77.913 149.378,77.913 171.739,94.57  171.739,118.127 149.378,134.785 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9811"
    },
    points: "133.566,77.913 117.753,77.913 95.392,94.57 95.392,106.087 133.566,106.087  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9811"
    },
    points: "133.566,134.785 149.378,134.785 171.739,118.127 171.739,106.11 133.566,106.11  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "117.753,434.085 95.392,417.427 95.392,393.871 117.753,377.213 149.378,377.213  171.739,393.871 171.739,417.427 149.378,434.085 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9811"
    },
    points: "133.566,377.213 117.753,377.213 95.392,393.871 95.392,405.388 133.566,405.388  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9811"
    },
    points: "133.566,434.085 149.378,434.085 171.739,417.427 171.739,405.411 133.566,405.411  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "117.753,284.435 95.392,267.777 95.392,244.221 117.753,227.563 149.378,227.563  171.739,244.221 171.739,267.777 149.378,284.435  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "172.522,321.085 162.782,321.085 162.782,311.346 145.667,311.346 133.565,299.244  121.464,311.346 104.349,311.346 104.349,321.085 94.61,321.085 94.61,340.563 104.349,340.563 104.349,350.302 121.463,350.302  133.566,362.405 145.667,350.302 162.782,350.302 162.782,340.563 172.522,340.563  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "172.522,171.434 162.782,171.434 162.782,161.694 145.667,161.694 133.565,149.592  121.464,161.694 104.349,161.694 104.349,171.434 94.61,171.434 94.61,190.912 104.349,190.912 104.349,200.651 121.463,200.651  133.566,212.755 145.667,200.651 162.782,200.651 162.782,190.912 172.522,190.912  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 122.434,
    y: 244.868,
    style: {
      fill: "#D80027"
    },
    width: 22.261,
    height: 22.261
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D80027"
    },
    cx: 133.564,
    cy: 181.169,
    r: 11.13
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D80027"
    },
    cx: 133.564,
    cy: 330.828,
    r: 11.13
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTm);
export default __webpack_public_path__ + "static/media/tm.3231a0ba334af1042bf5016313c6020c.svg";
export { ForwardRef as ReactComponent };